import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import FirebaseHandler from "./index";
import { mapSubscriptionDurationFromFirebase } from "../../util/subscription/subscriptions";
import { httpsCallable } from "firebase/functions";
export var checkCoupon = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(code) {
        var checkCoupon, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        checkCoupon = httpsCallable(FirebaseHandler.functions, "checkCoupon");
                        _context.next = 3;
                        return checkCoupon({
                            code: code
                        });
                    case 3:
                        res = _context.sent;
                        return _context.abrupt("return", Object.assign({}, res.data, {
                            assignedArticles: res.data.assignedArticles.map(function (article) {
                                return {
                                    type: article.type,
                                    duration: mapSubscriptionDurationFromFirebase(article.duration)
                                };
                            })
                        }));
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function checkCoupon(_x) {
        return _ref.apply(this, arguments);
    };
}();
export var CheckCouponResult;
(function (CheckCouponResult) {
    CheckCouponResult["VALID"] = "valid";
    CheckCouponResult["INVALID"] = "invalid";
    CheckCouponResult["ALREADY_USED"] = "already_used";
})(CheckCouponResult || (CheckCouponResult = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["FIXED"] = "fixed";
    DiscountType["PERCENT"] = "percent";
})(DiscountType || (DiscountType = {}));
